export default class MemberRelation {
    static fromData(data) {
        if (!data) {
            return;
        }

        let relation = new MemberRelation();
        relation.id = data.id;
        relation.type = data.type;
        relation.memberA = MemberRelationMember.fromData(data.memberA);
        relation.memberB = MemberRelationMember.fromData(data.memberB);

        Object.seal(relation);
        return relation;
    }
}

export class MemberRelationMember {
    fullName() {
        let fullName = this.lastName;

        if (this.firstName) {
            fullName = this.firstName + ' ' + fullName;
        }

        return fullName;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let member = new MemberRelationMember();
        member.id = data.id;
        member.firstName = data.firstName;
        member.lastName = data.lastName;
        member.gender = data.gender;
        member.hasAvatar = data.hasAvatar;
        member.avatarFileName = data.avatarFileName;
        member.hasDefaultInvoiceReceiver = data.hasDefaultInvoiceReceiver;

        Object.seal(member);
        return member;
    }
}
